import { UiStorylineModel } from "../../models";

import { mockCaptionModel } from "./mock-caption";

export function mockUiStorylineModel({
    id = "ui-storyline-1234",
    type = "uiStoryline",
    locale = "en",
    content = mockUiStorylineModelContent()
}: Partial<UiStorylineModel> = {}): UiStorylineModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiStorylineModelContent = UiStorylineModel["content"];

export function mockUiStorylineModelContent({
    title = "Title here",
    stories = [mockCaptionModel()],
    ...optionals
}: Partial<UiStorylineModelContent> = {}): UiStorylineModelContent {
    return {
        title,
        stories,
        ...optionals
    };
}
